import React, { useEffect, useRef } from 'react';
import { useTranslation } from '../../contexts/TranslationContext';

/** Native top layer keeps embedded asset controls above either viewer's canvas/chrome. */
export default function AssetDialog({ children, onClose, label }: { children: React.ReactNode; onClose: () => void; label: string }) {
  const ref = useRef<HTMLDialogElement>(null);
  const { isRTL, t } = useTranslation();
  useEffect(() => { const node = ref.current; node?.showModal(); return () => node?.close(); }, []);
  return <dialog ref={ref} className="dt-asset-dialog" dir={isRTL ? 'rtl' : 'ltr'} aria-label={label}
    onCancel={event => { event.preventDefault(); onClose(); }}
    onKeyDown={event => event.stopPropagation()} onClick={event => { event.stopPropagation(); if (event.target === event.currentTarget) onClose(); }}>
    <header><strong>{label}</strong><button className="dt-btn sm" aria-label={t('close')} onClick={onClose}>×</button></header>{children}
  </dialog>;
}
